import React from 'react';

import Node from 'craft/components/Node';
import Placeholder from 'craft/components/Placeholder';
import { BuiltInComponents } from 'craft/constants';
import { useNodeContext } from 'craft/hooks';
import { Resolver } from 'craft/types';
import { hasDescendants } from 'craft/utils';

export const COLLECTIONITEM_DEFAULT_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  flexShrink: 0,
  padding: 8,
};

export const CollectionItem: Resolver = ({ children, ...props }: any) => {
  const { id: nodeId } = useNodeContext();
  const hasChildren = hasDescendants(children);
  return (
    <Node id={nodeId} is="div" data-cy="node-collection-listitem" {...props}>
      {hasChildren ? children : <Placeholder />}
    </Node>
  );
};

CollectionItem.craft = {
  name: BuiltInComponents.CollectionItem,
  isCanvas: true,
};
